var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-state"},[_c('span',{staticClass:"material-icons empty-state__icon"},[_vm._v(_vm._s(_vm.icon))]),_c('p',{staticClass:"empty-state__description"},[_vm._v(_vm._s(_vm.description))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }